import { SnackbarState } from "@app/types";
import { readonly, ref } from "vue";

const isSnackbarShown = ref(false);
const state = ref<SnackbarState>();
const content = ref<string>();
let timeout: ReturnType<typeof setTimeout>;

export default () => {
  function show(snackbarState: SnackbarState, snackbarContent: string, duration: number = 6000) {
    isSnackbarShown.value = false;
    setTimeout(() => (isSnackbarShown.value = true), 0);
    state.value = snackbarState;
    content.value = snackbarContent;
    clearTimeout(timeout);
    timeout = setTimeout(() => (isSnackbarShown.value = false), duration);
  }

  function hide() {
    isSnackbarShown.value = false;
    clearTimeout(timeout);
  }

  function success(content: string) {
    show(SnackbarState.SUCCESS, content, 2000);
  }

  function error(content: string) {
    show(SnackbarState.ERROR, content, 6000);
  }

  return {
    isShown: readonly(isSnackbarShown),
    content: readonly(content),
    state: readonly(state),
    show,
    hide,
    success,
    error,
  };
};
